'use client';
//import { useRef, useState } from 'react';
import { useRef } from 'react';
import { MediaBlock as IMediaBlock } from '@/components/types';
//import clsx from 'clsx';
import Image from 'next/image';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules';
import type { Swiper as SwiperType } from 'swiper';
import 'swiper/css';
import 'swiper/css/pagination';
//import NavigationArrow from '../../../public/nav_arrow.svg';

import { Navigation, A11y, Autoplay } from 'swiper/modules';
import ContentContainer from '../layout/ContentContainer';

const SwiperCarousel = ({ block }: { block: IMediaBlock }) => {
  const swiperRef = useRef<SwiperType | null>(null);
  //const theme = block.theme || 'light';
  // const [activeIndex, setActiveIndex] = useState(0);

  return block.images ? (
    <>
      <div className="flex max-w-full justify-center rounded-xl p-4">
        <Swiper
          modules={[Navigation, Pagination, A11y, Autoplay]}
          slidesPerView={1}
          loop={true}
          spaceBetween={0}
          centeredSlides={true}
          autoplay={{
            delay: 5000,
            disableOnInteraction: false,
          }}
          a11y={{ enabled: true }}
          onSwiper={swiper => {
            swiperRef.current = swiper;
          }}
          //onSlideChange={swiper => setActiveIndex(swiper.activeIndex)}
          className="mySwiper aspect-2/1 w-full overflow-hidden"
        >
          {block.images.map((image, idx) => (
            <SwiperSlide
              key={`media-block-swiper-slide-${idx}`}
              className="overflow-hidden"
            >
              <div className="relative h-full w-full">
                <Image
                  src={image.url?.url || ''}
                  alt={image.alt || ''}
                  fill
                  className="object-contain"
                  sizes="(max-width: 1200px) 100vw, 1200px"
                />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>

      {/* Custom pagination and arrows below, only if more than one image */}
      {/* Pagination and Navigation removed temporarily
      {block.images.length > 1 && (
        <div className="mt-6 flex items-center justify-center gap-4">
          {/* Pagination dots }
          <div className={clsx('hidden gap-2 lg:flex')}>
            {block.images?.map((_, idx) => (
              <button
                key={`media-block-pagination-dot-${idx}`}
                className={clsx(
                  'h-3 w-3 rounded-full transition-all hover:cursor-pointer',
                  theme === 'light'
                    ? activeIndex === idx
                      ? 'bg-white'
                      : 'bg-gray-400'
                    : activeIndex === idx
                      ? 'bg-qf-purple'
                      : 'bg-[#D9D9D9]',
                )}
                onClick={() => swiperRef.current?.slideTo(idx)}
              />
            ))}
          </div>
          {/* Arrows }
          <div className="hidden gap-1 rounded-full border border-gray-200 lg:flex">
            <button
              className={clsx(
                'group m-1 flex h-10 w-10 items-center justify-center rounded-full hover:cursor-pointer hover:bg-gray-100 disabled:cursor-not-allowed disabled:opacity-50',
                'bg-qf-purple/10',
              )}
              onClick={() => swiperRef.current?.slidePrev()}
              disabled={activeIndex === 0}
            >
              <NavigationArrow
                className={clsx(
                  theme === 'light'
                    ? 'group-hover:text-qf-purple text-white'
                    : 'text-qf-purple',
                )}
              />
            </button>
            <button
              className={clsx(
                'group m-1 flex h-10 w-10 items-center justify-center rounded-full hover:cursor-pointer hover:bg-gray-100 disabled:cursor-not-allowed disabled:opacity-50',
                'bg-qf-purple/10',
              )}
              onClick={() => swiperRef.current?.slideNext()}
              disabled={activeIndex === (block.images?.length || 0) - 1}
            >
              <NavigationArrow
                className={clsx(
                  'rotate-180',
                  theme === 'light'
                    ? 'group-hover:text-qf-purple text-white'
                    : 'text-qf-purple',
                )}
              />
            </button>
          </div>
        </div>
      )} */}
    </>
  ) : null;
};

export default function MediaBlock({ block }: { block: IMediaBlock }) {
  return block.images ? (
    <ContentContainer>
      <SwiperCarousel block={block} />
    </ContentContainer>
  ) : null;
}
